import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {PAGES_AND_PATHS} from "../../../../constants/pages-and-paths";
import {SettingsHttpService} from "../../../../services/http-services/settings/settings-http.service";
import {AuthenticationHelperService} from "../../../../services/helpers/authentication-helper.service";
import {InsightsDetailsTypeEnums} from "../../../../enums/profile-enums";
import {TranslateModule} from "@ngx-translate/core";
import {DecimalPipe, NgForOf} from "@angular/common";
import {MatchLocaleModule} from '../../../../pipes/match-locale/match-locale.module';

@Component({
  selector: 'tl-insights-index',
  standalone: true,
  imports: [
    TranslateModule,
    DecimalPipe,
    NgForOf,
    MatchLocaleModule
  ],
  templateUrl: './insights-index.component.html',
})
export class InsightsIndexComponent implements OnChanges {
  @Input() urlParams: {from_date: string | null, to_date: string | null} = {from_date: null, to_date: null};
  @Output() clickOnCard: EventEmitter<string> = new EventEmitter<string>();
  @Output() clickOnList: EventEmitter<any> = new EventEmitter<any>();
  @Output() clickOnViewAllBtn: EventEmitter<void> = new EventEmitter<void>();
  insightsOverview: any;
  insightsLists: any[] = [];
  profileData: any;
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;
  protected readonly InsightsDetailsTypeEnums = InsightsDetailsTypeEnums;
  constructor(private settingsHttpService: SettingsHttpService,
              private authHelperService: AuthenticationHelperService) { }
  ngOnInit(): void {
    this.getInsightsOverview();
    this.getInsightsLists();
    this.profileData = this.authHelperService.getUserData;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.urlParams) {
      this.urlParams = changes.urlParams.currentValue;
      this.getInsightsOverview();
      this.getInsightsLists();
    }
  }
  getInsightsOverview(): void {
    this.settingsHttpService.getInsightsOverview(this.urlParams).then(res => {
      this.insightsOverview = res.data;
    });
  }
  getInsightsLists(): void {
    this.settingsHttpService.getInsightsLists({...this.urlParams, page: 1}).then(res => {
      this.insightsLists = res.data;
    });
  }
}
